export const baseData = {
  title: "CATEGORY CUSTOMER"
}